export default '/build/2c328391.jpg'